import { useState, useCallback } from "react";

/**
 * A custom hook to manage the open/closed state of a component like a modal or dropdown.
 * @param {boolean} initialState - The initial open state.
 * @returns {{
 *   isOpen: boolean,
 *   onOpen: () => void,
 *   onClose: () => void,
 *   onToggle: () => void
 * }}
 */
export function useDisclosure(initialState = false) {
  const [isOpen, setIsOpen] = useState(initialState);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((prev) => !prev), []);

  return { isOpen, onOpen, onClose, onToggle };
}
